export { ProblemsConsoleTabComponent } from './problems-console-tab.component';
